import React, { Component } from 'react';
import { Button } from 'reactstrap';
import styles from './Header.module.css';
import person from '../images/person.svg';
import gear from '../images/gear.svg';
import logo from '../images/logo.svg';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class Header extends Component {
  logOut = () => {
    localStorage.removeItem('kvk-vb-token');
    // this.props.history.push('/');
    window.location.reload(false);
  };

  login = () => {
    this.props.history.push('/login', this.props.location.pathname);
  };

  onClickManageUsers = () => {
    this.props.history.push('/users', this.props.location.pathname);
  };
 
  render() {
    const { loading, isAuthenticated, role } = this.props.me;

    return (
      <div className={styles.wrapper}>
        <div className={styles.main} style={{maxWidth: this.props.pageWidth }}>
          <div className={styles.title}>
            {this.props.logoURL ? (
              <img src={this.props.logoURL} alt="logo" style={{ maxHeight: '40px', marginRight: '6px' }} />
            ) : (
              <img src={logo} alt="logo" style={{ maxHeight: '40px', marginRight: '6px' }} />
            )}
          </div>
          <span className={styles.title} style={{ float: this.props.alignTitle || 'right' }}>
            {this.props.title || 'Connected Apps'}
            {this.props.onClick && (
              <img
                onClick={this.props.onClick}
                src={gear}
                alt="gear"
                style={{ paddingLeft: '12px', cursor: 'pointer' }}
              />
            )}
          </span>
          {!loading && isAuthenticated && (
            <div className={styles.auth}>
              <img src={person} alt="person" />
              <div className={styles.nameContainer}>
                <div style={{ lineHeight: '1.1em' }}>{this.props.me.name}</div>
                {(role === 'admin' || role === 'superadmin') && (
                  <Button color="link" style={{ padding: '0', fontSize: '0.8em' }} onClick={this.onClickManageUsers}>
                    Gebruikers beheren
                  </Button>
                )}
              </div>
              <Button color="link" onClick={this.logOut}>
                Log out
              </Button>
            </div>
          )}
          {!loading && !isAuthenticated && !this.props.noLoginButton && (
            <div className={styles.auth}>
              <Button color="primary" onClick={this.login}>
                Login
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  me: state.me
});

Header = withRouter(Header);

export default connect(mapStateToProps)(Header);
